import * as React from "react";
import {
  Text,
  StyleSheet,
  View,
  TextInput,
  Image,
  TouchableOpacity,
  Dimensions,
} from "react-native";
// import { useNavigation } from "@react-navigation/native"; a part of cleaner code
import GlobalStyles from "../components/GlobalStyles";
import FooterBarWide from "../components/footerBarWide";
import MenuBar from "../components/headers/MenuBar";
import StatusBar from "../components/headers/StatusBar";

export default function InviteMultipleFriendsScreen() {
  // const navigation = useNavigation(); a part of cleaner code
  const win = Dimensions.get("window");
  return (
    <View style={GlobalStyles.containerMB}>
      {win.width > 768 ? (
        <View style={GlobalStyles.fullHeaderBarY}>
          <MenuBar />
          <View style={GlobalStyles.headerContainerKLYellow}>
            <View style={[GlobalStyles.headerTextYellow]}>
              <Text style={GlobalStyles.headingStyle}>Invite your friends</Text>
              {/* <Text style={GlobalStyles.subheaderStyle}>
                Share the Aura success and give your friends and family 
               $5 tostart investing with Aura! And we’ll give you $5 as well! Terms     appl
              </Text> */}
              <Text style={GlobalStyles.subheaderStyle}>
                Share the Aura success and give your friends and family
              </Text>
            </View>
          </View>
        </View>
      ) : (
        <View style={GlobalStyles.fullHeaderBarW}>
          <StatusBar data="BM" />
          <View style={GlobalStyles.headerContainerKL}>
            <View style={[GlobalStyles.headerText]}>
              <Text style={GlobalStyles.headingStyle}>Invite your friends</Text>
              {/* <Text style={GlobalStyles.subheaderStyle}>
                Share the Aura success and give your friends and family 
               $5 tostart investing with Aura! And we’ll give you $5 as well! Terms     appl
              </Text> */}
              <Text style={GlobalStyles.subheaderStyle}>
                Share the Aura success and give your friends and family
              </Text>
            </View>
          </View>
        </View>
      )}
      <View style={GlobalStyles.bodyContainerT}>
        <View style={styles.containerBodyBox}>
          <TextInput
            placeholder="Enter email addresses"
            style={styles.textInput}
            underlineColorAndroid="transparent"
          />
          <TextInput
            placeholder="Enter email addresses"
            style={styles.textInput}
            underlineColorAndroid="transparent"
          />
          <TextInput
            placeholder="Enter email addresses"
            style={styles.textInput}
            underlineColorAndroid="transparent"
          />
          <TextInput
            placeholder="Enter email addresses"
            style={[styles.textInput, { borderBottomWidth: 0 }]}
            underlineColorAndroid="transparent"
          />
        </View>
        <View style={styles.centerHeaderContent}>
          <TouchableOpacity
            style={styles.SubmitButtonStyle}
            activeOpacity={0.5}
          >
            <Text style={styles.textStyle}> SEND INVITES </Text>
          </TouchableOpacity>
        </View>
      </View>
      <View style={GlobalStyles.webFooter}>
        {win.width > 768 ? <FooterBarWide /> : null}
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  centerHeaderContent: {
    justifyContent: "center",
    marginTop: 30,
  },

  SubmitButtonStyle: {
    paddingTop: 15,
    paddingBottom: 15,
    backgroundColor: "#337599",
    borderRadius: 30,
  },

  containerBodyBox: {
    backgroundColor: "#FFFF",
    borderBottomLeftRadius: 10,
    borderBottomRightRadius: 10,
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    paddingLeft: 20,
    paddingRight: 20,
    paddingTop: 10,
    paddingBottom: 10,
  },

  textStyle: {
    color: "#fff",
    textAlign: "center",
    fontFamily: "montserrat-bold",
    fontSize: 16,
  },

  textInput: {
    borderColor: "#CCCCCC",
    borderBottomWidth: 1,
    height: 40,
    fontSize: 16,
    paddingRight: 20,
    fontFamily: "montserrat-regular",
    textAlign: "center",
  },

  inputBoarder: {
    borderBottomWidth: 1,
    borderBottomColor: "gray",
    marginLeft: 50,
    marginRight: 50,
  },

  bodyStyle: {
    fontFamily: "montserrat-regular",
    fontSize: 12,
    textAlign: "center",
    marginBottom: 5,
  },
});
